"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isScheduler = isScheduler;
function isScheduler(value) {
    return value && typeof value.schedule === 'function';
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/rxjs/static-5.4/util/isScheduler.js
// module id = 159
// module chunks = 171